import type { WatchlistSymbol } from '@benzinga/watchlist-manager';
import { normalizeWatchlistSymbol } from '@benzinga/watchlist-manager';

import type { WatchlistFinancials } from '../data';

type AlertFields = Pick<WatchlistSymbol, 'isPR' | 'isSEC' | 'sendRealtime'>;

export const hasWatchlistTickerAlerts = (
  watchlistSymbol: AlertFields | null | undefined,
): boolean => Boolean(watchlistSymbol?.isPR || watchlistSymbol?.isSEC || watchlistSymbol?.sendRealtime);

export const syncWatchlistSymbolsIntoRows = (
  rows: WatchlistFinancials[],
  symbols: WatchlistSymbol[],
): WatchlistFinancials[] => {
  if (rows.length === 0 || symbols.length === 0) return rows;

  const symbolsByKey = new Map(
    symbols.map(symbol => [normalizeWatchlistSymbol(symbol.symbol), symbol] as const),
  );

  let changed = false;
  const nextRows = rows.map(row => {
    const watchlistSymbol = symbolsByKey.get(normalizeWatchlistSymbol(row.symbol));
    if (!watchlistSymbol || watchlistSymbol === row.watchlistSymbol) return row;
    changed = true;
    return {
      ...row,
      holdings: watchlistSymbol.holding ?? row.holdings,
      watchlistSymbol,
    };
  });

  return changed ? nextRows : rows;
};
